import { Button, styled } from "@mui/material";
import { HoverElevationButton } from "./base-buttons";

// TODO: make generic buttons, add colors when needed
// Add button
export const ActionButton = styled(HoverElevationButton)(({ theme }) => ({
    backgroundColor: theme.barekam.actionbar.buttons.newOrder.backgroundColor,
    color: '#FFF',

    padding: '12px 24px 12px 24px',
    height: '3rem',

    justifyContent: 'center',
    alignItems: 'center',
    display: 'inline-flex',
    gap: '0.75rem',

    '&:hover': {
        backgroundColor: theme.barekam.actionbar.buttons.newOrder.backgroundColor,
    },
    '& img': {
        width: '17px',
        height: '17px',
        filter: 'brightness(1000%) saturate(0%) contrast(1000%)'
    }
}));

export const ActionButtonSmall = styled(ActionButton)(() => ({
    height: '3rem'
}));

export const ActionButtonExtraSmall = styled(ActionButton)(() => ({
    padding: '1.125rem 1.5rem',
    height: '2.5rem',
    width: '9.25rem',
}));

const ActionButtonCard = styled(Button)(({ theme }) => ({
    color: '#FFF',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '20rem',
    height: '100%',
    flexDirection: 'column',

    gap: '1.5rem',
    padding: '1.5rem 1.5rem 0.75rem 0.75rem',
    borderRadius: '0.5rem',

    backgroundColor: theme.barekam.recipient.buttons.add.backgroundColor,

    '&:hover': {
        backgroundColor: theme.barekam.recipient.buttons.add.backgroundColor,
    },

    '&:active': {
        boxShadow: '0px 0px 10px 0px rgba(69, 77, 102, 0.30) inset'
    }
}));

export const ActionButtonFilledCard = styled(ActionButtonCard)(() => ({

}))

export const ActionButtonOutlinedCard = styled(ActionButtonCard)(({ theme }) => ({
    color: theme.barekam.lightGrey,
    gap: 'unset',
    width: '18.25rem',
    height: '5.75rem',
    borderRadius: '0.5rem',
    border: `1px solid ${theme.barekam.additionalService.border.default}`,
    backgroundColor: 'rgb(255, 255, 255)',
    boxShadow: '0px 3px 3px rgba(0, 0, 0, 0.1)',

    '&:hover': {
        background: theme.barekam.grey,// TODO: change colors
    },
}))

// Cancel button
export const CancelButtonSmall = styled(ActionButtonSmall)(({ theme }) => ({
    border: `2px solid ${theme.barekam.mediumGrey}`,
    backgroundColor: '#fff',
    color: theme.palette.common.black,
    width: 'max-content',

    '&:hover': {
        background: theme.barekam.mediumGrey,// TODO: change colors
    },
}));

// Remove button
export const RemoveButton = styled(Button)(() => ({

}));

export const RemoveButtonSmall = styled(RemoveButton)(() => ({
    padding: '18px 18px 18px 18px',
    height: '40px',
    width: '148px',
}));

export const RemoveButtonLarge = styled(RemoveButton)(() => ({
    padding: '18px 18px 18px 18px',
    height: '346px',
    width: '320px',
}));

export const RecipientsButton = styled(Button)(({ theme }) => ({
    border: `1px solid ${theme.barekam.green}`,
    boxSizing: 'border-box',
    borderRadius: 0,
    width: '206px',
    height: '60px',
}));

export const ChangeMethodButton = styled(Button)(({ theme }) => ({
    backgroundColor: theme.barekam.darkGrey,
    color: 'ff0000',
    boxSizing: 'border-box',
    borderRadius: 0,
    width: '127px',
    height: '30px',
}));

export const TopUPButton = styled(Button)(({ theme }) => ({
    border: `1px solid ${theme.barekam.green}`,
    backgroundColor: theme.barekam.green,
    color: 'ff0000',
    boxSizing: 'border-box',
    borderRadius: 0,
    width: '127px',
    height: '30px',
}));

